import type {
  GetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags200,
  GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200,
  GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile200,
} from '@fukuri-admins/apis/client/gen/model';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import {
  useGetPartnerAdminsPartnerFeatureFlags,
  useGetPartnerAdminsUser,
  useGetPartnerAdminsUserProfile,
} from '~/hooks';
import { getEnvFeatureFlag } from '~/utils/getEnvFeatureFlag';

type IUseUserDetailProfile = (userId: number) => {
  state: {
    data: GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200;
    profileData: GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdProfile200;
    /**
     * 環境フィーチャーフラグ（staging / development 環境で true）
     *
     * 表示可否の導出は logics/convertToPresentationProps 側で行う。
     */
    enableStaging: boolean;
    /**
     * PartnerFeatureFlag 一覧を含む API レスポンス（activation_code の有効判定に使う）
     *
     * 一覧の取り出し・有効判定は logics/convertToPresentationProps 側で行う。
     */
    partnerFeatureFlagsData: GetApiV1ThreeLetterCodePartnerAdminsPartnerFeatureFlags200;
  };
};

/**
 * 利用者詳細プロフィールのコンポーネントフック
 *
 * @param userId - 利用者ID
 */
export const useUserDetailProfile: IUseUserDetailProfile = userId => {
  const threeLetterCode = getThreeLetterCode() ?? '';
  const { enableStaging } = getEnvFeatureFlag();

  // 取得のみを担い、表示可否（isActivationCodeEnabled）の導出は
  // logics/convertToPresentationProps 側に委譲する。
  const { data: partnerFeatureFlagsData } = useGetPartnerAdminsPartnerFeatureFlags({
    threeLetterCode,
  });

  const { data } = useGetPartnerAdminsUser({ threeLetterCode, userId });
  const { data: profileData } = useGetPartnerAdminsUserProfile({ threeLetterCode, userId });

  return {
    state: {
      data,
      profileData,
      enableStaging,
      partnerFeatureFlagsData,
    },
  };
};
